export function decimalToHours(n: number) {
  const num = n * 60
  const hours = Math.floor(num / 60)
  const minutes = num % 60
  return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`
}
